module.exports = __webpack_public_path__ + "static/media/launay4PaysageLarge.6188ce59.JPG";